import React from 'react'
import { Table } from 'react-bootstrap'
import { inject, observer } from 'mobx-react'
import { ContingentRows } from '../../ProductsOverview/Structure'
import SelectedAmountsRow from './SelectedAmountsRow'
import { t } from 'i18next'

import styled from 'styled-components'
const StyledHeaderTr = styled.tr`
  th {
    .pending-delivery-info {
      font-size: small;
      color: gray;
      font-weight: initial;
    }
  }
`
const ResponsiveTableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;

  @media (max-width: 767px) {
    .react-bs-table-no-data {
      display: none;
    }

    table {
      empty-cells: show;
      width: 100%;
    }

    thead > tr > th {
      width: 50%;
      display: inline-block;
      border: 0.5px solid gray;
      text-align: center;
    }

    .fullWidthMobile {
      width: 100%;
      display: inline-block;
    }

    tbody,
    td,
    tr {
      display: block;
    }

    th::after {
      display: none;
    }

    tr:nth-child(2n) {
      background: #ccc;
    }

    td {
      border: none;
      border-bottom: 1px solid #eee;
      empty-cells: show !important;
      position: relative;
      white-space: normal;
      text-align: left;
    }

    td::before {
      position: absolute;
      top: 6px;
      left: 6px;
      width: 44%;
      white-space: nowrap;
      text-align: left;
      font-weight: bold;
    }

    .actions-header-cell,
    .checkBox-header-cell {
      display: none;
    }

    .actions-cell {
      width: 100% !important;
    }
  }
`

const SelectedAmounts = inject('inventoryStore')(
  observer((props) => {
    const { inventoryStore } = props
    const hasPositions = (position) =>
      position.rows &&
      (position.rows.length || inventoryStore.actionType === 'assets')
    const showContingent = (contingent) =>
      contingent.categories.some((category) =>
        category.articles.some((article) =>
          article.positions.some(
            (position) =>
              hasPositions(position) /*position.rows && position.rows.length*/
          )
        )
      )
    const showCategory = (category) =>
      category.articles.some((article) =>
        article.positions.some(
          (position) =>
            hasPositions(position) /*position.rows && position.rows.length*/
        )
      )
    const showArticle = (article) =>
      article.positions.some(
        (position) =>
          hasPositions(position) /*position.rows && position.rows.length*/
      )
    const showPosition = (position) =>
      hasPositions(position) /*position.rows && position.rows.length*/

    let fakeCatalogArticlesContingent = {
      displayName: t('other'),
      categories: [{ articles: inventoryStore.editCatalogArticles }],
    }
    return (
      <>
        {inventoryStore.contingents ? (
          <ResponsiveTableWrapper>
            <Table borderless>
              <tbody>
                {/* Contingent Articles */}
                {inventoryStore.contingents.map((contingent) => {
                  if (!showContingent(contingent)) {
                    return null
                  }
                  return (
                    <ContingentRows
                      key={contingent.id}
                      contingent={contingent}
                      withoutImg
                    >
                      {contingent.categories.map((category) => {
                        if (!showCategory(category)) {
                          return null
                        }
                        return (
                          <React.Fragment key={category.id}>
                            <tr data-id={`category-${category.id}`}>
                              <td colSpan='5'>
                                <h2 className='mt-3'>{category.displayName}</h2>
                              </td>
                            </tr>
                            {/*<tr>*/}
                            <StyledHeaderTr>
                              <th>{t('name')}</th>
                              <th>{t('inventory:articleNr')}</th>
                              <th>{t('size')}</th>
                              {inventoryStore.actionType === 'assets' && (
                                <th>Max</th>
                              )}
                              <th>
                                {t('quantity')}
                                {inventoryStore.actionType === 'assets' && (
                                  <div className='pending-delivery-info'>
                                    * {t('inventory:pendingDelivery')}
                                  </div>
                                )}
                              </th>
                              {/*</tr>*/}
                            </StyledHeaderTr>
                            {category.articles.map((article) => {
                              if (!showArticle(article)) {
                                return null
                              }
                              return article.positions.map((position) => {
                                if (!showPosition(position)) {
                                  return null
                                }
                                return (
                                  <SelectedAmountsRow
                                    key={`${article.id}_${
                                      position.articleVariant
                                        ? position.articleVariant.id
                                        : '_'
                                    }`}
                                    article={article}
                                    position={position}
                                  />
                                )
                              })
                            })}
                          </React.Fragment>
                        )
                      })}
                    </ContingentRows>
                  )
                })}
                {/* Catalog Articles */}
                {showContingent(fakeCatalogArticlesContingent) ? (
                  <>
                    <ContingentRows
                      contingent={fakeCatalogArticlesContingent}
                      withoutImg
                    ></ContingentRows>
                    {inventoryStore.editCatalogArticles.map((article) =>
                      article.positions.map((position) => {
                        if (!showPosition(position)) {
                          return null
                        }
                        return (
                          <SelectedAmountsRow
                            key={`${article.id}_${
                              position.articleVariant
                                ? position.articleVariant.id
                                : '_'
                            }`}
                            article={article}
                            position={position}
                          />
                        )
                      })
                    )}
                  </>
                ) : null}
              </tbody>
            </Table>
          </ResponsiveTableWrapper>
        ) : null}
      </>
    )
  })
)

export default SelectedAmounts
